
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event]/galerien/[slug]",
      function () {
        return require("private-next-pages/[event]/galerien/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event]/galerien/[slug]"])
      });
    }
  